<template>
  <span aria-hidden="true" />
</template>

<script>
export default {
  name: 'AppDismissibleAlerts',
  data() {
    return {
      observer: null,
      frame: null,
    };
  },
  mounted() {
    this.manageAlerts();

    this.observer = new MutationObserver(() => {
      this.scheduleManageAlerts();
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  },
  beforeUnmount() {
    if (this.frame) {
      cancelAnimationFrame(this.frame);
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    scheduleManageAlerts() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
      }

      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.manageAlerts();
      });
    },
    manageAlerts() {
      document.querySelectorAll('.alert, .login-alert').forEach((alert) => {
        if (!(alert instanceof HTMLElement)) {
          return;
        }

        const signature = this.getAlertSignature(alert);
        const previousSignature = alert.dataset.appAlertSignature || '';

        alert.classList.add('app-dismissible-alert');

        if (previousSignature && previousSignature !== signature) {
          alert.classList.remove('app-alert-dismissed');
        }

        alert.dataset.appAlertSignature = signature;

        // Une fermeture gérée par Vue doit conserver son propre changement d'état.
        if (!alert.querySelector('.btn-close, [data-bs-dismiss="alert"], .app-alert-close')) {
          const closeButton = document.createElement('button');
          closeButton.type = 'button';
          closeButton.className = 'btn-close app-alert-close';
          closeButton.setAttribute('aria-label', 'Fermer le message');
          closeButton.addEventListener('click', () => {
            alert.classList.add('app-alert-dismissed');
          });

          alert.appendChild(closeButton);
        }
      });
    },
    getAlertSignature(alert) {
      return Array.from(alert.childNodes)
        .filter((node) => !(node instanceof HTMLElement && node.matches('.btn-close, [data-bs-dismiss="alert"], .app-alert-close')))
        .map((node) => node.textContent || '')
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();
    },
  },
};
</script>
